import { createFileRoute } from '@tanstack/react-router'
import { guardAuthed, RouteError } from '@pa/staff'
import { AdminShell } from '@/features/shell'

/** Every admin page: the guards (Frontend §5.3 rows 1–3), then the S-00 shell. */
export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ context, location }) => guardAuthed(context, 'admin', location.href),
  component: function AuthedLayout() {
    const { env } = Route.useRouteContext()
    return <AdminShell envLabel={env.VITE_ENV_LABEL} />
  },
  errorComponent: RouteError,
})
